const Popover = {
    $popovers: null,
    
    init() {
        this.$popovers = document.querySelectorAll('.popover');

        this.$popovers.forEach($popover => {
            this.initPopover($popover);
        });
    },

    initPopover($popover) {
        const that = this;
        const $toggler = $popover.querySelector('.popover-toggler');
        const $close = $popover.querySelector('.popover-tooltip-close');

        $toggler.addEventListener('click', e => {
            that.togglePopover($popover);
        });

        $close.addEventListener('click', e => {
            that.closePopover($popover);
        });
    },

    togglePopover($popover) {
        if (!$popover.classList.contains('open')) {
            const $tooltip = $popover.querySelector('.popover-tooltip');

            const tooltipClientRect = $tooltip.getBoundingClientRect();

            if (tooltipClientRect.right > (window.innerWidth - 50)) {
                $tooltip.style.transform = 'translateX(-' + ((tooltipClientRect.right - window.innerWidth) + 50) + 'px)';
            } else if (tooltipClientRect.left < 0) {
                $tooltip.style.transform = 'translateX(50px)';
            }
        }

        this.$popovers.forEach($p => {
            if ($p !== $popover) {
                $p.classList.remove('open');
            } else {
                $p.classList.toggle('open');
            }
        });
    },

    closePopover($popover) {
        $popover.classList.remove('open');
    }
}

export default Popover;